// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".trace-traceWrapper-93bdc{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.trace-trace-a77ec .trace-title-ce05f .trace-subtitle-c7ebd{font-size:12px}.trace-trace-a77ec .trace-extra-714a1 .trace-refresh-e1550{margin-right:8px}.trace-trace-a77ec .trace-configCard-3f562{padding:0}.trace-alert-c3e3c{margin-bottom:12px}.trace-alert-c3e3c .trace-content-a53d1{display:flex;justify-content:space-between}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"traceWrapper": "trace-traceWrapper-93bdc",
	"trace": "trace-trace-a77ec",
	"title": "trace-title-ce05f",
	"subtitle": "trace-subtitle-c7ebd",
	"extra": "trace-extra-714a1",
	"refresh": "trace-refresh-e1550",
	"configCard": "trace-configCard-3f562",
	"alert": "trace-alert-c3e3c",
	"content": "trace-content-a53d1"
};
export default ___CSS_LOADER_EXPORT___;
